<template>
  <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
  <div v-if="loading" id="loading">
    <img :src="imageSrc" id="loading-image" alt="Loading" />
  </div>
  <CarousalComponent ref="carousalRef"></CarousalComponent>
  <api-handler ref="handleApi"></api-handler>

  <api-handler ref="handleApiOnLoad"></api-handler>
  <div class="button-container">
    <button
      class="btn btn-primary listBtn"
      @click="
        CallApi(
          'https://api.themoviedb.org/3/movie/popular?language=en-US&page=1'
        )
      "
    >
      Popular
    </button>
    <button
      class="btn btn-success listBtn"
      @click="
        CallApi(
          'https://api.themoviedb.org/3/movie/top_rated?language=en-US&page=1'
        )
      "
    >
      Top Rated
    </button>
    <button
      class="btn btn-info listBtn"
      @click="
        CallApi(
          'https://api.themoviedb.org/3/movie/upcoming?language=en-US&page=1'
        )
      "
    >
      Upcoming
    </button>
  </div>
  <div class="movieList m-6 d-flex justify-content-center">
    <div
      class="card"
      style="width: 18rem"
      v-for="movie in movieList"
      :key="movie.id"
      @click="redirectToRoute(movie.id)"
    >
      <img
        class="card-img-top"
        :src="`https://image.tmdb.org/t/p/w400/ + ${movie.image}`"
        alt="Card image cap"
      />
      <div class="card-body">
        <h4 class="card-text">
          {{ movie.title }}
        </h4>
        <!-- <p class="card-text">
          {{movie.overview}}
        </p> -->
      </div>
    </div>
  </div>

  <!-- <h1>US population data</h1>

  <button class="btn btn-primary btn-sm" @click="CallApi">Call Api</button> -->

  <!-- <div class="form-group">
      <label for="exampleFormControlTextarea1"> Get Data</label>
      <textarea v-model="apiContent" class="form-control"></textarea>
    </div> -->
  <!-- <div class="row">
    <div class="col col-lg-5">
      <h4>Data :</h4>
      <table class="table align-middle mb-0 bg-white">
        <thead class="bg-light">
          <tr>
            <th>Nation</th>
            <th>Year</th>
            <th>Population</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in populationTableData[0]" :key="item.Year">
            <td>{{ item.Nation }}</td>
            <td>{{ item.Year }}</td>
            <td>{{ item.Population }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col col-lg-7">
      <BarChart ref="updateChart" />
    </div>
  </div>
  <div class="col col-lg-12">
    <DThreeCharts />
  </div>
  <div class="col col-lg-12">
    <h4>Annotations :</h4>
    <table class="table align-middle mb-0 bg-white">
      <thead class="bg-light">
        <tr>
          <th>Source Name</th>
          <th>Source Description</th>
          <th>Dataset Name</th>
          <th>Dataset Link</th>
          <th>Table ID</th>
          <th>Topic</th>
          <th>Subtopic</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ annotationTableData.source_name }}</td>
          <td>{{ annotationTableData.source_description }}</td>
          <td>{{ annotationTableData.dataset_name }}</td>
          <td><a :href="annotationTableData.dataset_link">Link</a></td>
          <td>{{ annotationTableData.table_id }}</td>
          <td>{{ annotationTableData.topic }}</td>
          <td>{{ annotationTableData.sub_topic }}</td>
        </tr>
      </tbody>
    </table>
  </div> -->
</template>

<script>
import { nextTick } from "vue";
import ApiHandler from "@/components/ApiHandler.vue";
import CarousalComponent from "@/components/CarousalComponent.vue";
export default {
  name: "HomeView",
  components: {
    ApiHandler,
    CarousalComponent,
  },
  async created() {
    //this.CallApi();
    nextTick(() => {});
  },
  data() {
    return {
      loading: true,
      imageSrc: require("@/assets/loading.gif"),
      apiContent: "",
      annotationTableData: [],
      populationTableData: [],
      customChartData: [],
      customChartLabels: [],
      currentApiScope: "",
      url: "",
      movieList: [],
    };
  },
  async mounted() {
    let nowPlayingUrl =
      "https://api.themoviedb.org/3/movie/now_playing?language=en-US&page=1";
    let popularUrl =
      "https://api.themoviedb.org/3/movie/popular?language=en-US&page=1";
    const nowPlayingList = await this.$refs.handleApi.fetchData(nowPlayingUrl);
    const popularList = await this.$refs.handleApi.fetchData(popularUrl);

    // create now playing carosal
    const apiData = nowPlayingList;
    let apiDataResults = apiData.results;
    var carousalData = [];
    for (let i = 0; i < apiDataResults.length; i++) {
      carousalData[i] = {
        title: apiDataResults[i].title,
        id: apiDataResults[i].id,
        image:
          "https://image.tmdb.org/t/p/original/" +
          apiDataResults[i].poster_path,
      };
    }
    this.$refs.carousalRef.updateCarosal(carousalData);

    // create MovieList
    const popularApiData = popularList;
    apiDataResults = popularApiData.results;

    for (let i = 0; i < apiDataResults.length; i++) {
      this.movieList[i] = {
        title: apiDataResults[i].title,
        id: apiDataResults[i].id,
        overview: apiDataResults[i].overview,
        image:
          "https://image.tmdb.org/t/p/original/" +
          apiDataResults[i].poster_path,
      };
    }
    this.loading = false;
  },
  methods: {
    async CallApi(url) {
      this.loading = true;
      const apiDataList = await this.$refs.handleApi.fetchData(url);
      console.log("api data list : " + apiDataList);

      // create MovieList
      const ListApiData = apiDataList;
      const apiDataResults = ListApiData.results;

      for (let i = 0; i < apiDataResults.length; i++) {
        this.movieList[i] = {
          title: apiDataResults[i].title,
          id: apiDataResults[i].id,
          overview: apiDataResults[i].overview,
          image:
            "https://image.tmdb.org/t/p/original/" +
            apiDataResults[i].poster_path,
        };
      }
      this.loading = false;
    },
    redirectToRoute(movieId) {
      this.$router.push(`/movie/${movieId}`);
    },
  },
};
</script>

<style scoped>
/* Inserting this collapsed row between two flex items will make 
 * the flex item that comes after it break to a new row */
.break {
  flex-basis: 100%;
  height: 0;
}

.card {
  margin: 0px 20px;
  cursor: pointer;
}

.movieList {
  margin: 20px;
  flex-wrap: wrap;
  gap: 20px;
}

.button-container {
  display: flex;
  justify-content: center;
}

.listBtn {
  margin: 0px 20px;
}

#loading {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.7;
  background-color: #fff;
  z-index: 99;
}

#loading-image {
  z-index: 100;
}
</style>
